import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 3,
    pb: 3,
    px: 3,
  },
  iconShape: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '24px',
    bgcolor: 'orange.lightest',
    p: 1.5,
    width: 48,
    height: 48,
    flexShrink: 0,
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
    width: '100%',
  },
  descriptionRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
    mt: 0.5,
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    width: '100%',
  },
  optionCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    border: '1px solid',
    borderColor: 'gray.8',
    borderRadius: '12px',
    px: 2,
    py: 1.75,
    cursor: 'pointer',
    bgcolor: 'gray.0',
    transition: 'box-shadow 0.2s ease',
  },
  optionCardSelected: {
    boxShadow: '0px 4px 20px 0px rgba(0,0,0,0.15)',
  },
  priceText: {
    fontWeight: 600,
    color: 'primary.main',
  },
  tooltipWrapper: {
    display: 'block',
  },
}
